import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Archive (= suppression Stripe d'une fiche VIDE, vérifiée en direct) — UNE fiche à la fois, après « ARCHIVER »
export function ArchiveCustomerButton({ cid, email, onArchived }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data: chk } = await api.get(`/ops/audit/stripe-customer/${cid}/archive-check`);
      if (!chk.can_archive) { toast.error(`Non archivable : ${chk.reasons.join(" · ")}`); setBusy(false); return; }
      const c = chk.customer;
      const typed = window.prompt(`Archiver la fiche Stripe ${cid} ?\n\n• ${c.name || "sans nom"} · ${c.email}\n• créée le ${(c.created || "").slice(0, 10)} · ${c.subscriptions_total} abonnement(s) (aucun vivant) · 0 paiement · ${c.payment_methods} carte(s)\n• autres fiches avec ce courriel : ${c.siblings.join(", ")}\n\nStripe n'a pas d'« archivage » client : la fiche VIDE est supprimée définitivement (une copie reste dans le journal). Aucun abonnement ni paiement n'est touché.\n\nTape ARCHIVER pour confirmer :`, "");
      if (typed === null) { setBusy(false); return; }
      const { data } = await api.post(`/ops/audit/stripe-customer/${cid}/archive`, { confirm_text: typed });
      toast.success(`Fiche ${data.archived} archivée`);
      onArchived?.(cid);
    } catch (e) { toast.error(e?.response?.data?.detail || "Archivage impossible"); }
    setBusy(false);
  };
  return <button onClick={run} disabled={busy} className="ml-2 text-[10px] border border-rose-500/40 text-rose-300 hover:bg-rose-500/10 px-2 py-0.5 disabled:opacity-50" title={`Vérifier en direct puis archiver ${cid} (${email})`} data-testid={`archive-cus-${cid}`}>{busy ? "…" : "🗄 Archiver dans Stripe"}</button>;
}

// Nommer en 1 clic une fiche Stripe « sans nom » (ou dont le nom est un courriel) — non financier
export function NameCustomerButton({ cid, onNamed }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data: s } = await api.get(`/ops/audit/stripe-customer/${cid}/name-suggestions`);
      const list = s.suggestions.length ? `\n\nSuggestions (élèves/parents de ${s.email}) :\n${s.suggestions.map((n, i) => `${i + 1}. ${n}`).join("\n")}\n\nTape un numéro ou écris le nom :` : `\n\nAucune suggestion locale pour ${s.email}. Écris le nom :`;
      const typed = window.prompt(`Nommer la fiche Stripe ${cid}${s.current_name ? ` (actuellement « ${s.current_name} »)` : " (sans nom)"} ?${list}`, s.suggestions[0] || "");
      if (typed === null || !typed.trim()) { setBusy(false); return; }
      const idx = parseInt(typed.trim(), 10);
      const name = Number.isInteger(idx) && s.suggestions[idx - 1] ? s.suggestions[idx - 1] : typed.trim();
      const { data } = await api.post(`/ops/audit/stripe-customer/${cid}/name`, { name });
      toast.success(`Fiche ${cid} nommée « ${data.name} »`);
      onNamed?.(cid, data.name);
    } catch (e) { toast.error(e?.response?.data?.detail || "Nommage impossible"); }
    setBusy(false);
  };
  return <button onClick={run} disabled={busy} className="ml-2 text-[10px] border border-sky-500/40 text-sky-300 hover:bg-sky-500/10 px-2 py-0.5 disabled:opacity-50" data-testid={`name-cus-${cid}`}>{busy ? "…" : "✏️ Nommer"}</button>;
}

// Rapport mensuel (1er du mois) + envoi manuel
export function MonthlyDupReport() {
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState(null);
  const preview = async () => {
    setBusy(true);
    try { const { data } = await api.get("/ops/audit/stripe-duplicates/monthly/preview"); setInfo(data); const w = window.open("", "_blank"); if (w) { w.document.write(data.html); w.document.close(); } }
    catch (e) { toast.error(e?.response?.data?.detail || "Aperçu impossible"); }
    setBusy(false);
  };
  const send = async () => {
    if (!window.confirm("M'envoyer maintenant le rapport doublons Stripe (courriel au propriétaire) ?")) return;
    setBusy(true);
    try { const { data } = await api.post("/ops/audit/stripe-duplicates/monthly/send-now?confirm=true"); toast.success(data.sent ? `Rapport envoyé à ${data.to}` : `Non envoyé : ${data.skipped}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Envoi impossible"); }
    setBusy(false);
  };
  return (
    <div className="mt-3 flex items-center gap-2 flex-wrap text-xs text-white/60 border-t border-white/10 pt-3" data-testid="monthly-dup-report">
      <span>📅 Rapport mensuel automatique le <b className="text-white/80">1er de chaque mois à 8 h</b> (courriel au propriétaire) : vérifie que le résolveur unique tient bon (delta vs mois précédent).{info?.config?.last_run?.at && <> Dernier envoi : {info.config.last_run.at.slice(0, 10)}.</>}</span>
      <button onClick={preview} disabled={busy} className="border border-white/20 hover:border-white/50 text-white px-3 py-1 disabled:opacity-50" data-testid="monthly-dup-preview">👁 Aperçu</button>
      <button onClick={send} disabled={busy} className="border border-white/20 hover:border-white/50 text-white px-3 py-1 disabled:opacity-50" data-testid="monthly-dup-send">✉️ M'envoyer maintenant</button>
    </div>
  );
}
